module.exports = __webpack_public_path__ + "static/media/ironforge.09342c53.jpg";